import BatchCheckpoints from '../BatchCheckpoints';
import { ErrorPage } from '@/pages/Layout/pages';
import { RouteObject } from 'react-router-dom';
import { Authorize } from '@/components';
import {
  BUSINESS_ROLE_GROUPS,
  EXTERNAL_OPERATOR_ROLE_GROUPS,
} from '@/components/security/AppRoles';

const RESTRICTED_PERMISSIONS = [
  ...BUSINESS_ROLE_GROUPS.operations,
  ...EXTERNAL_OPERATOR_ROLE_GROUPS.restricted,
];

const BatchCheckpointsRoutes: RouteObject[] = [
  {
    path: 'batch-checkpoints',
    children: [
      {
        path: '',
        element: (
          <Authorize
            permission={RESTRICTED_PERMISSIONS}
            fallback={<ErrorPage code={403} />}
          >
            <BatchCheckpoints />
          </Authorize>
        ),
      },
    ],
  },
];

export default BatchCheckpointsRoutes;
